'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { AccordionBody } from './Body';
import { AccordionHeader } from './Header';
import { AccordionSection, isAccordionSection } from './Section';
import * as Styles from './styles';
export const AccordionContext = React.createContext({
    icon: 'plus',
    variant: 'filled',
    showBorder: false,
    multiOpen: false,
    withAnimation: false,
    activeSectionIds: [],
    setActiveSectionIds: () => { },
});
export const useAccordionContext = () => React.useContext(AccordionContext);
const Accordion = ({ children, icon = 'plus', variant = 'filled', multiOpen = false, showBorder = false, withAnimation = false, ...rest }) => {
    const childrenArray = React.Children.toArray(children);
    const defaultActiveSectionIds = React.useMemo(() => {
        const activeChildren = childrenArray
            .filter(isAccordionSection)
            .filter(child => child.props.defaultIsActive);
        if (activeChildren.length > 0) {
            if (multiOpen)
                return activeChildren.map(({ props }) => props.id).filter(Boolean);
            return activeChildren.length > 0 && activeChildren[0] ? [activeChildren[0].props.id] : [];
        }
        return [];
    }, [childrenArray, multiOpen]);
    const [activeSectionIds, setActiveSectionIds] = React.useState(defaultActiveSectionIds);
    return (_jsx(AccordionContext.Provider, { value: {
            icon,
            variant,
            showBorder,
            multiOpen,
            withAnimation,
            activeSectionIds,
            setActiveSectionIds,
        }, children: _jsx(Styles.List, { "$variant": variant, ...rest, children: children }) }));
};
Accordion.Section = AccordionSection;
Accordion.Header = AccordionHeader;
Accordion.Body = AccordionBody;
export { Accordion };
//# sourceMappingURL=index.js.map